import ImageSlider from '@/components/ImageSlider'
import vuewidget from './vuewidget'

export default function(dom, opts) {

	const imageElements = [].slice.call(dom.querySelectorAll('.image-slider__slide-data'), 0);
	const images = imageElements.map(image => JSON.parse(image.dataset.data));

	let options = {
		...opts,
		images,
		vueComponent: ImageSlider
	}

	let page = vuewidget(dom, options)
	return page
}